import type { Character } from "@/mocks/siteData";
import { images } from "@/mocks/images";

export default function CharacterCard({
  character,
  size = "normal",
}: {
  character: Character;
  size?: "normal" | "compact";
}) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-primary-300">
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-background-200">
        <img
          src={images[character.imgSeq]}
          alt={`${character.name}——${character.role}`}
          title={`${character.name} ${character.role}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-3 py-1 text-xs font-bold text-background-50 backdrop-blur">
          {character.role}
        </span>
      </div>
      <div className={`flex flex-1 flex-col p-4 md:p-5 ${size === "compact" ? "gap-1" : "gap-2"}`}>
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            {character.name}
          </h3>
          <span className="whitespace-nowrap text-xs text-foreground-500">
            {character.identity}
          </span>
        </div>
        <p className={`text-sm leading-relaxed text-foreground-600 ${size === "compact" ? "line-clamp-3" : ""}`}>
          {character.intro}
        </p>
        <div className="mt-auto flex flex-wrap gap-1.5 pt-3">
          {character.keywords.map((kw) => (
            <span
              key={kw}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900"
            >
              {kw}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}